import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class APDSalaryTypeGroupingDTO  {
    _originalTypeClassName = "zERP.BO.APDSalaryTypeGroupingDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
APDSalaryTypeGroupingDTO.translate = translateService;
}
this.Name = null;
this.TotalSalary = null;
this.TotalContributions = null;
this.APDSalaryTypeGroupingDTOKey = null;
this._key = this.APDSalaryTypeGroupingDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
TotalSalary:any;
TotalContributions:any;
private _APDSalaryTypeGroupingDTOKey:any;
get APDSalaryTypeGroupingDTOKey(): any {
    return this._APDSalaryTypeGroupingDTOKey;
  }
set APDSalaryTypeGroupingDTOKey(value: any) {
    this._APDSalaryTypeGroupingDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.APDSalaryTypeGroupingDTOKey == null || $this.APDSalaryTypeGroupingDTOKey == 0;
            }


}